import { io } from 'socket.io-client';
let socket = null;

export const initializeSocket = (locationId, clientId) => {
    socket = io(process.env.VUE_APP_NODE_API_BASE_URL, {
        query: {locationId, clientId},
        transports: ['websocket', 'polling']
    });
    return socket;
}

export const getSocket = () =>{
    if (!socket){
        throw new Error("Socket not initialized! Call initializeSocket first.");
    }
    return socket;
}

export default {initializeSocket, getSocket};